/*
  System Info State - Getters.
*/

/* ---------------------------------------------------------- */
/* Feature Flags */

/**
 * Retrieve the list of Feature Flags.
 * @param {*} state 
 * @returns List of Feature Flags.
 */
export function getFeatureFlags(state) {
  return state.systemSettings.featureFlags;
};

/**
 * Retrieve the 'enabled' value for the specified Feature Flag.
 * @param {string} name Feature Flag name.
 * @returns Enabled flag for specified Feature.
 */
export function getFeatureFlagValue(state, getters) {
  return (name) => {
    const featureFlag = state.systemSettings.featureFlags.find(ff => ff.name === name);
    if (!featureFlag) console.warn(`SystemInfo.getFeatureFlagValue Unrecognised Feature Flag: '${name}'`);
    return featureFlag?.enabled?true: false;
  };
};

/* ---------------------------------------------------------- */
/* Specific Feature Flags */

/**
 * Check if the Feature Flag if 'Version 4'.
 * @param {*} data Feature Flag data.
 * @returns True is Feature Flag is of type 'Version 4'.
 */
export function isFeatureFlag_Version4(state) {
  return (data) => {
    return data?.name === state.systemSettings.featureFlagNames.version4;
  };
};

/**
 * Determine whether 'Version 4' Feature Flag is enabled.
 * @returns FeatureFlags.Version4.Enabled.
 */
export const getFeatureFlagValue_Version4 = (state, getters) => {
  return getters.getFeatureFlagValue(state.systemSettings.featureFlagNames.version4);
};

/* ---------------------------------------------------------- */
